import { useEffect, useState } from "react"
import { getAPI } from "../api/api"
import { GraphComp } from "./graphComp"

export const DashboardBoardGraph = ({customerStage}) => {


    const [activeGraph, setActiveGraph] = useState(0)
    const [graphOptions, setGraphOptions] = useState([{"name":"kies"}])
    const [graphPeriod, setGraphPeriod] = useState(6)
    const [graphSats, setGraphSats] = useState([{"name":"Kies een module", }])
    const [isLoading, setIsLoading] = useState(0)

    const loadGraphs = async() => {
        const query = `api/reports/dashboard/options?customer_stage=${customerStage}`
        const graph = await getAPI(query)
       
        setGraphOptions(graph.data)
        return graph.data
    }
    const initDashboard  = async () => {
        const data = await loadGraphs()
        if(data.length){
            await loadGraphStats(data[0].id_dashboard)
        }

    }
    useEffect(() => {
        initDashboard()
    },[])
    const loadGraphStats = async (id, period=graphPeriod) => {
        const query = `api/reports/dashboard/graph?id_dashboard=${id}&period=${period}&customer_stage=${customerStage}`
        const load_graph = await getAPI(query)
        const data = load_graph.dataset;
        console.log(data)
        setGraphSats(data);
    }
    const setIdBusiness = (id) => {
        const filteredID = graphOptions.findIndex(option => option.id_dashboard == id)
        setActiveGraph(filteredID)
    }
    const handlePeriod = (id) => {
        setGraphPeriod(id)
        loadGraphStats(graphOptions[activeGraph].id, id)
    }
    const handleReport = async (id) => {
        setIdBusiness(id)
        loadGraphStats(id)
    }
    return <GraphComp loading={isLoading} options={graphOptions}  setStatKeys={handleReport} title={graphOptions[activeGraph]?.pretty_name} dataset={graphSats} graph={"bar"} value={graphPeriod} period={graphPeriod} setPeriod={ handlePeriod} loadStats={loadGraphStats} graphStats={graphSats} />

}